import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getAllIntegrations } from "./services/integration.services";
import { useNavigate } from "react-router-dom";
import useWindowSize from "../../_hooks/useWindowSize";
import { LoadingPanel } from "../../components/layout/Loading";
import AlertBox from "../../components/common/AlertBox";

const DESKTOP_WIDTH = 992;

const LeadCenter: React.FC = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const loading = useAppSelector((state) => state.integration.loading);
  const LeadIntegrationList = useAppSelector(
    (state) => state.integration.LeadIntegrationList
  );
  useEffect(() => {
    dispatch(getAllIntegrations());
  }, []);

  const handleStudentLead = (FormID: string) => {
    navigate("/integrations/studentleads", {
      state: {
        FormID: FormID,
      },
    });
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <GridLayout style={{ padding: 10 }} cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <GridLayout
            style={{
              marginRight: 20,
            }}
            gap={{ cols: 10, rows: 10 }}
            cols={[
              { width: "33.33%" },
              { width: "33.33%" },
              { width: "33.33%" },
            ]}
          >
            <GridLayoutItem
              colSpan={3}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "4px 20px 20px 0",
              }}
            >
              <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
                Lead Center
              </Typography.h4>
            </GridLayoutItem>
            <GridLayoutItem colSpan={3}>
              <GridLayout
                style={{
                  marginRight: width > DESKTOP_WIDTH ? 30 : 20,
                }}
                gap={{ cols: 10, rows: 10 }}
                cols={
                  width > DESKTOP_WIDTH
                    ? [
                        { width: "25%" },
                        { width: "25%" },
                        { width: "25%" },
                        { width: "25%" },
                      ]
                    : [
                        { width: "33.33%" },
                        { width: "33.33%" },
                        { width: "33.33%" },
                      ]
                }
              >
                {LeadIntegrationList && LeadIntegrationList?.length > 0 ? (
                  LeadIntegrationList?.map((integration: any) => {
                    return (
                      <GridLayoutItem>
                        <div
                          className="integration-card"
                          onClick={() =>
                            integration?.FormIDCount > 0 &&
                            handleStudentLead(integration?.FormID)
                          }
                        >
                          <p className="m-0 fw-bold">{integration?.Title}</p>
                          <span
                            style={{
                              padding: "2px 7px",
                              background: "#303F9F",
                              color: "white",
                              borderRadius: "16px",
                            }}
                          >
                            {integration?.FormIDCount}
                          </span>
                        </div>
                      </GridLayoutItem>
                    );
                  })
                ) : (
                  <GridLayoutItem colSpan={4}>
                    <AlertBox />
                  </GridLayoutItem>
                )}
              </GridLayout>
            </GridLayoutItem>
          </GridLayout>
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default LeadCenter;
